const Footer = () => {
  return (
    <div className="text-center p-3 m-3 mt-10">
      <h4>This site is developed by Mo Yasir @2023 💎</h4>
    </div>
  );
};

export default Footer;
